import React from "react";
import { NavUser } from "@/layout/components/nav-user";
import { TeamSwitcher } from "@/layout/components/team-switcher";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "ui/components/sidebar";
import { NavMain } from "./nav/main";

const MainSidebar = ({ ...props }) => {
  return (
    <Sidebar
      collapsible="icon"
      {...props}
      className="sidebar-height border-r bg-blue-600 z-50"
    >
      <SidebarHeader>
        <TeamSwitcher />
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
};

export default MainSidebar;
